import { Dispatch } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import { showAlert } from './utils';

export const handleError = (error: any) => {
  if (error.response?.data) {
    console.log('Response Error: ', error.response.data.message);
    return alert(error.response.data.message);
  } else {
    if (error.code) console.log('Unexpected Error: ', error);
    return alert(error);
  }
};

export const errorHandler = (
  dispatch: Dispatch,
  error: unknown,
  defaultMessage: string = 'Ocurrió un error al procesar la solicitud',
) => {
  console.error(error);

  let message = defaultMessage;

  if (isAxiosError(error) && error.response?.data) {
    const responseData = error.response.data as { message?: string };
    if (responseData.message) {
      message = responseData.message;
    }
  } else if (error instanceof Error) {
    message = error.message;
  }

  showAlert(dispatch, 'error', message);
};

function isAxiosError(error: unknown): error is AxiosError {
  return error !== null && typeof error === 'object' && 'isAxiosError' in error;
}
